import { ref } from "vue";

// 전역 로그인 다이얼로그 상태 관리
const isLoginDialogOpen = ref(false);
const loginDialogRef = ref(null);
const isExternalOpen = ref(false); // 외부에서 호출되었는지 여부

/**
 * 로그인 다이얼로그 열기
 */
export const openLoginDialog = () => {
  isLoginDialogOpen.value = true;
  isExternalOpen.value = true; // 외부에서 호출된 것으로 표시
  
  // VDialog ref가 있으면 직접 제어
  if (loginDialogRef.value) {
    if (typeof loginDialogRef.value.toggle === "function") {
      loginDialogRef.value.toggle();
    }
  }
};

/**
 * 로그인 다이얼로그 닫기
 */
export const closeLoginDialog = () => {
  isLoginDialogOpen.value = false;
  isExternalOpen.value = false; // 플래그 리셋
  
  if (loginDialogRef.value && typeof loginDialogRef.value.close === "function") {
    loginDialogRef.value.close();
  }
};

/**
 * 로그인 다이얼로그 composable
 */
export const useLoginDialog = () => {
  return {
    isLoginDialogOpen,
    loginDialogRef,
    isExternalOpen,
    openLoginDialog,
    closeLoginDialog,
  };
};

